/**
 * feature/map — spec §F5 (Map Explorer). Route `/`.
 * Composition so far: the Leaflet canvas (§F5.1) + the hierarchy boundary layers from
 * PostGIS (§F5.8/§D2) + the sidebar (§F5.2) + the choropleth (§F5.3) + the legend and its
 * style editor (§F5.6) + the Operational hierarchy widget (§F5.8) + the unit profile
 * (§F5.7) + the search box, time bar and status bar (§F5.10) + the mini indicator dock and
 * its popover (§F5.9) + the map-tool column with its basemap panel, measure/draw/swipe
 * behaviours and §G6 AOI clip (§F5.10) + the §F6 analysis dock.
 *
 * Every floating widget is a child of `MapView` so that `#mapwrap` is its containing block
 * — which is also the box `lib/draggable.ts` clamps against (§F5.11).
 */
import { MapView } from './MapView';
import { HierarchyLayers } from './HierarchyLayers';
import { Choropleth } from './Choropleth';
import { Overlays } from './Overlays';
import { RasterLayers } from './RasterLayers';
import { ResultLayers } from './ResultLayers';
import { VectorLayers } from './VectorLayers';
import { MapTools } from './MapTools';
import { SearchBox } from './SearchBox';
import { StatusBar } from './StatusBar';
import { IndicatorDock } from '../widgets/IndicatorDock';
import { IndicatorPopover } from '../widgets/IndicatorPopover';
import { Legend } from '../widgets/Legend';
import { OperationalHierarchy } from '../widgets/OperationalHierarchy';
import { TimeBar } from '../widgets/TimeBar';
import { UnitProfile } from '../widgets/UnitProfile';
import { Sidebar, SidebarToggle } from '../sidebar';
import { AnalysisDock } from '../analysis';

export function MapPage() {
  return (
    <div id="view-map" className="view">
      <Sidebar />
      <MapView>
        {/* Order here is irrelevant to stacking — every layer names its §F5.1 pane — but
            it reads bottom-up on the map: rasters (z350), choropleth (z400), boundaries
            (z420), thematic vectors and §F5.5 overlay symbols (z450), §F6 analysis
            results (z460). */}
        <RasterLayers />
        <Choropleth />
        <HierarchyLayers />
        <VectorLayers />
        <Overlays />
        <ResultLayers />
        <SidebarToggle />
        <SearchBox />
        <MapTools />
        <OperationalHierarchy />
        <Legend />
        <TimeBar />
        <UnitProfile />
        <IndicatorDock />
        <IndicatorPopover />
        {/* §F6. Last of the floating panels because it is the widest and the most recent
            thing the reader asked for; it renders nothing at all while it is closed. */}
        <AnalysisDock />
        <StatusBar />
      </MapView>
    </div>
  );
}

export { MapView };
export default MapPage;
